import BaseModalController from "./base_modal_controller";

export default class extends BaseModalController {
  static values = {
    ...BaseModalController.values,
    priority: { type: Number, default: 5 },
    queueable: { type: Boolean, default: true },
    autoShow: { type: Boolean, default: true }
  }

  getShowDelay() {
    return 500;
  }

  linkClicked() {
    this.updateAutoEnrollSetting();
  }

  onDismiss() {
    this.updateAutoEnrollSetting();
  }

  updateAutoEnrollSetting() {
    fetch('/auto_enroll_setting', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      }
    })
    .then(async response => {
      if (response.ok) {
        return response.json();
      } else {
        const data = await response.json();
        throw new Error(`HTTP error! status: ${response.status} - ${data.error}`);
      }
    })
  }
}
